import { render } from "./RecordsTable.vue?vue&type=template&id=381b2792"
import script from "./RecordsTable.vue?vue&type=script&lang=js"
export * from "./RecordsTable.vue?vue&type=script&lang=js"

import "./RecordsTable.vue?vue&type=style&index=0&id=381b2792&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__